import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import VoterInfos from 'lib/VoterInfos/VoterInfos';
import PollBarFragment from './PollBarFragment';
import { PollResult, PollSubType } from '../../api/api.types';

interface Props {
  result: PollResult;
  participation: number;
  isReduced?: boolean;
  showVoterInfoAbove?: boolean;
  eligibleVoters?: number;
  subtype: PollSubType;
}

const PollBar = ({
  result,
  participation,
  isReduced,
  showVoterInfoAbove,
  eligibleVoters,
  subtype,
}: Props) => {
  const { t } = useTranslation('wap');

  const yesI18nKey = subtype === 'tie_break' ? 'vi_votes_label' : 'yes_votes_label';
  const noI18nKey = subtype === 'tie_break' ? 'ge_votes_label' : 'no_votes_label';

  return (
    <div className={classNames('pollbar', { 'pollbar--small': isReduced })}>
      {showVoterInfoAbove && (
        <VoterInfos eligibleVoters={eligibleVoters} participation={participation} />
      )}
      <div className="pollbar__relatives">
        <div className="pollbar__relatives-yes">
          <span>
            {t(yesI18nKey, { value: result?.yes_votes_percentage?.toFixed(2) })}
          </span>
        </div>
        <div className="pollbar__relatives-no">
          <span>{t(noI18nKey, { value: result?.no_votes_percentage?.toFixed(2) })}</span>
        </div>
      </div>
      <div className="pollbar__bar">
        <PollBarFragment votes={result?.yes_votes_percentage} type="yes" />
        <PollBarFragment votes={result?.no_votes_percentage} type="no" />
      </div>
      <div className="pollbar__absolutes">
        <div className="pollbar__absolutes-yes">
          <span className="poll__visuallyhidden">
            {t('yes_votes_screen_reader_info')}
          </span>
          {t('absolute_votes', { count: result?.yes_votes })}
        </div>
        <div className="pollbar__absolutes-no">
          <span className="poll__visuallyhidden">{t('no_votes_screen_reader_info')}</span>
          {t('absolute_votes', { count: result?.no_votes })}
        </div>
      </div>
      {!showVoterInfoAbove && (
        <VoterInfos eligibleVoters={eligibleVoters} participation={participation} />
      )}
    </div>
  );
};

PollBar.defaultProps = {
  isReduced: false,
};

export default PollBar;
